
import './App.css';
import React, {useState} from 'react'
import Navbar from './Component/Navbar';
import News from './Component/News';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoadingBar from "react-top-loading-bar";

export default function App (){

  const apiKey = '75863c78a2e74dababb0c56d4470518b'
  const [progress,setProgress] = useState(0);



    return (
 

          <Router>
     
          <Navbar />  
          <div><LoadingBar
               color="#f11946"
               progress= {progress}
               />
          </div>

          <Routes>
          <Route  path="/" element={<News apiKey={apiKey} setProgress= {setProgress}  pageSize={20} country="us" category="general" />} />
          <Route  path="/Entertainment" element={<News apiKey={apiKey} setProgress= {setProgress}  pageSize={20} country="us" category="entertainment" />} />
          <Route  path="/Business" element={<News apiKey={apiKey} setProgress= {setProgress}  pageSize={20} country="us" category="business" />}/>
          <Route  path="/General" element={<News apiKey={apiKey} setProgress= {setProgress}  pageSize={20} country="us" category="general" />} />
          <Route  path="/Health" element={<News apiKey={apiKey} setProgress= {setProgress}  pageSize={20} country="us" category="health" />} />
          <Route  path="/Science" element={<News apiKey={apiKey} setProgress= {setProgress}  pageSize={20} country="us" category="science" />} />
          <Route  path="/Sports" element={<News apiKey={apiKey} setProgress= {setProgress}  pageSize={20} country="us" category="sports" />} />
          <Route  path="/Technology" element={<News apiKey={apiKey} setProgress= {setProgress}  pageSize={20} country="us" category="technology" />} />
      
          {/* <Route  path="/Entertainment" element={<News key="Entertainment" apiKey={apiKey} setProgress= {setProgress}  pageSize={20} country="us" category="entertainment" />} />
          <Route  path="/Business" element={<News key="Business" apiKey={apiKey} setProgress= {setProgress}  pageSize={20} country="us" category="business" />}/>
          <Route  path="/General" element={<News key="General" apiKey={apiKey} setProgress= {setProgress}  pageSize={20} country="us" category="general" />} />
          <Route  path="/Health" element={<News key="Health" apiKey={apiKey} setProgress= {setProgress}  pageSize={20} country="us" category="health" />} />
          <Route  path="/Science" element={<News key="Science" apiKey={apiKey} setProgress= {setProgress}  pageSize={20} country="us" category="science" />} />
          <Route  path="/Sports" element={<News key="Sports" apiKey={apiKey} setProgress= {setProgress}  pageSize={20} country="us" category="sports" />} />
          <Route  path="/Technology" element={<News key="Technology" apiKey={apiKey} setProgress= {setProgress}  pageSize={20} country="us" category="technology" />} />
       */}

         </Routes>
         </Router>


    )
  
}

//0a520a7fb54a34e8a8c2552cebeabfd38